import { Trans as I18nTrans, TransProps } from "react-i18next";
import { useTranslationV2 as useGenericTranslation } from "waapi/front-utils/hooks/useTranslation/hook.js";
import { MystiqueTranslationKeys } from "./types.js";
import { translationKeys } from "./translationKeys.js";
import { StringMap, TOptions } from "i18next";
import { getDefaultValueFromTerm } from "./helpers/getDefaultValueFromTerm.js";

export const useMystiqueTranslation = () => {
    const { t, ...restGenericTranslationProps } = useGenericTranslation<MystiqueTranslationKeys>();

    const Trans = ({
        i18nKey,
        defaults: defaultsProp,
        ...restTransParams
    }: Omit<TransProps<MystiqueTranslationKeys>, "i18nKey"> & { i18nKey: MystiqueTranslationKeys }): JSX.Element => {
        const defaultValue = defaultsProp ?? getDefaultValueFromTerm(translationKeys, i18nKey);
        const defaults = defaultValue === "no default value" ? undefined : defaultValue;

        return <I18nTrans<MystiqueTranslationKeys> i18nKey={i18nKey} defaults={defaults} {...restTransParams} />;
    };

    const tWithDefaultValue = (key: MystiqueTranslationKeys, options?: TOptions<StringMap>) => {
        const defaultValue = getDefaultValueFromTerm(translationKeys, key);
        return t(key, { defaultValue, ...options });
    };

    return { ...restGenericTranslationProps, t: tWithDefaultValue, Trans };
};
